
// import RNFS from 'react-native-fs';

/**
 * Upload image file to S3 (guest/public access)
 * @param {string} uri - Local file URI
 * @param {string} fileName - Desired file name (e.g., `image.jpg`)
 * @returns {Promise<string>} - The key of the uploaded file
 */
export async function uploadToS3(fileUri, fileName, mimeType = 'image/jpeg') {
  try {
    const s3 = new AWS.S3();


    if (fileUri) {
      const uri = fileUri;
      const response = await fetch(uri);
      const blob = await response.blob();

      try {
        const params = {
          Bucket: 'sb-all-images-data',
          Key: fileName, // e.g., "uploads/image1.jpg"
          Body: blob,
          ContentType: 'image/jpeg', // or other type
        };
        const data = await s3.upload(params).promise();
        console.log('File uploaded successfully:', data);
        return data;
      } catch (err) {
        console.log('Upload error:', err);
      }
    }
  } catch (error) {
    console.error('S3 upload failed:', error);
    throw error;
  }
}

/**
 * Get image URL from S3 (public access)
 * @param {string} fileName - File name/key (e.g., `uploads/image.jpg`)
 * @returns {Promise<string>} - Public image URL
 */
export const getImageFromS3 = async (fileName) => {
  try {
    const s3 = new AWS.S3();
    const bucketName = 'sb-all-images-data';
    const region = 'ca-central-1'; // change to your actual region
    const signedUrlExpireSeconds = 60 * 5 // your expiry time in seconds.

    const url = s3.getSignedUrl('getObject', {
      Bucket: bucketName,
      Key: fileName,
      Expires: signedUrlExpireSeconds
    })
    return url;
  } catch (error) {
    console.error('S3 Get Error:', error);
    throw error;
  }
};